import { apiConfig, createAxiosServiceInstance } from '../api';
import { AMLS_NS_IAD } from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();
const matchingConfigBaseUrl = `${apiConfig.serviceApi}${AMLS_NS_IAD}/matchingConfig`;
const headers = {
  'Content-Type': 'application/json'
};

export async function getMatchingConfigParameters(payload) {
  let url = `${matchingConfigBaseUrl}/tuningParameters`;
  if (payload) url = `${matchingConfigBaseUrl}/${payload?.id}/tuningParameters`;
  return await axios.get(url, { headers });
}

export async function getMatchingConfigRiskIndicatorsParameters(payload) {
  let url = `${matchingConfigBaseUrl}/riskIndicators`;
  if (payload) url = `${matchingConfigBaseUrl}/${payload?.id}/riskIndicators`;
  return await axios.get(url, { headers });
}

export async function getNSMatchingConfigList(payload) {
  const { limit, offset, sourceId } = payload;
  const params = {
    limit: limit || 5,
    offset: offset || 0,
    type: payload?.type
  };
  const matchingConfigUrl = matchingConfigBaseUrl + '/all/' + sourceId;
  return await axios.get(matchingConfigUrl, { headers, params }).then((res) => {
    return {
      ...res.data
    };
  });
}

export async function postNSCreateMatchingConfigAPI(payload) {
  let url = `${matchingConfigBaseUrl}`;

  return await axios.post(url, payload, { headers }).then((res) => {
    return res;
  });
}

export async function getNSMatchingConfigByIdService(payload) {
  let url = `${matchingConfigBaseUrl}/configDetails/` + payload?.id;

  return axios.get(url, payload, { headers }).then((res) => {
    return res.data;
  });
}

export async function getNSMatchingConfigAPI(payload) {
  let url = `${matchingConfigBaseUrl}/configDetails/${payload.id}`;

  return axios.get(url, { headers }).then((res) => {
    return res;
  });
}

export async function putNSUpdateMatchingConfigAPI(payload) {
  let url = `${matchingConfigBaseUrl}/${payload.id}`;

  return axios.put(url, payload, { headers }).then((res) => {
    return res;
  });
}

export async function getMatchingConfigRiskIndicatorList() {
  let url = `${matchingConfigBaseUrl}/riskIndicators`;
  return await axios.get(url, { headers });
}
